import { forwardRef } from "react";
import { Input, InputProps } from "./input";

type EmailInputProps = Omit<InputProps, "type">;

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>((props, ref) => {
  return <Input {...props} ref={ref} type="text" inputMode="email" />;
});

EmailInput.displayName = "EmailInput";
